<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span slot="title">Advertising</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <router-link :to="{ name: 'advertising', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Advertising
            </span>
          </router-link>
        </li>
      </ul>
      <div v-if="sum > 0" class="btn btn-group m-btn-group" slot="actions">
        <button class="btn btn-default" disabled>
          KES {{ sum }}
        </button>
        <button class="btn btn-success" @click="showPayModal" :disabled="sum === 0">
          Pay
        </button>
      </div>
    </bread-crumb>
    <dash-content>
      <div v-if="showBillboards" class="row" slot="content">
        <modal @closeModal="closeModal" v-if="showBillboardPayHistoryModal" size="modal-lg">
          <div slot="header">
            <h4 class="modal-title">Billboard Payment History</h4>
          </div>
          <div slot="body">
            <payment-history :billboard-id="selectedBillBoard"></payment-history>
          </div>
        </modal>
        <payment v-if="showPaymentModal" @closePaymentModal="closePaymentModal" :transaction-details="transactionDetails" card-tx-type="pay-for-billboards-card" mpesa-tx-type="pay-for-billboards-mobile-money">
          <table slot="items" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>
                  <strong>Item</strong>
                </th>
                <th>
                  <strong>Amount</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(billboard,key) in selectedBillBoards" :key="key">
                <td>{{ billboard.name }}</td>
                <td>KES {{ billboard.balance }}</td>
              </tr>
              <tr>
                <td>
                  <strong>TOTAL</strong>
                </td>
                <td>
                  <strong>KES {{ formatNumber(sum) }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </payment>
        <div class="col-md-8">
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    Billboards
                  </h3>
                </div>
              </div>
            </div>
            <div class="m-portlet__body">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>
                      <label class="m-checkbox">
                        <input type="checkbox" @change="selectAll" v-model="allSelected">
                        <span></span>
                      </label>
                    </th>
                    <th>Name</th>
                    <th>Location</th>
                    <th>Balance</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(billboard ,index) in billboards" :key="index">
                    <td>
                      <label class="m-checkbox" :class="{'m-checkbox--disabled': checkBillboard(billboard)}">
                        <input type="checkbox" :disabled="checkBillboard(billboard)" v-model="selectedBillBoards" :value="billboard" @change="billboardChanged">
                        <span></span>
                      </label>
                    </td>
                    <td>
                      <a href="javascript: void(0)" @click="showModal(billboard.billboardId)">
                        {{ billboard.name }}
                      </a>
                    </td>
                    <td>{{ billboard.location }}</td>
                    <td>{{ billboard.balance }}</td>
                    <td>
                      <span class="badge" :class="statusClass[billboard.status]">
                        {{ status[billboard.status] }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <instructions>
            <ol slot="instructions">
              <li>Select the billboard</li>
              <li>Click on Pay</li>
              <li>Select your payment option</li>
              <li>Click on Proceed to complete the process</li>
            </ol>
          </instructions>
        </div>
      </div>
    </dash-content>
  </div>
</template>
<script>
import api from "../../../api";
import helper from "../../../helpers";
import Modal from "../../Modal";
import BreadCrumb from "../../partials/BreadCrumb";
import Instructions from "../../partials/Instructions";
import DashContent from "../../partials/Content";
import payment from "../../checkout/Payment";
import paymentHistory from "./datatables/PaymentHistory";

export default {
  name: "Advertising",
  data() {
    return {
      sum: 0,
      allSelected: false,
      params: this.$route.params,
      selectedBillBoard: "",
      loading: false,
      transactionDetails: {},
      billboards: [],
      selectedBillBoards: [],
      showBillboards: false,
      showPaymentModal: false,
      countyId: this.$route.params.countyId,
      showBillboardPayHistoryModal: false,
      token: this.$store.state.token,
      status: [
        "Pending Approval",
        "Active",
        "Edited",
        "Deactivation Request",
        "Inactive",
        "Deleted"
      ],
      statusClass: [
        "badge-warning",
        "badge-success",
        "badge-warning",
        "badge-warning",
        "badge-danger",
        "badge-danger"
      ]
    };
  },
  components: {
    Modal,
    BreadCrumb,
    Instructions,
    payment,
    DashContent,
    paymentHistory
  },
  methods: {
    formatNumber(number) {
      return helper.formatNumber(number);
    },
    calculateSum() {
      this.sum = 0;
      for (let billboard of this.selectedBillBoards) {
        this.sum = Number(this.sum) + Number(billboard.balance);
      }
    },
    closeModal() {
      document.body.classList.remove("modal-open");
      this.showBillboardPayHistoryModal = false;
    },
    showModal(selectedBillBoard) {
      document.body.classList.add("modal-open");
      this.showBillboardPayHistoryModal = true;
      this.selectedBillBoard = selectedBillBoard;
    },
    loadBillBoards() {
      const txType = "get-billboards";
      let data = {
        token: this.token,
        countyId: this.countyId
      };
      helper.loading(true);
      api
        .request(txType, data)
        .then(response => {
          if (response.data.status === "00") {
            helper.loading(false);
            this.billboards = response.data.billboards;
            this.showBillboards = true;
          } else {
            helper.info({ show: true, message: response.data.message });
          }
        })
        .catch(error => {
          helper.error({
            show: true,
            message: "An error occured. Please try again later"
          });
          console.log(error);
        });
    },
    showPayModal() {
      if (this.selectedBillBoards.length === 0) {
        helper.errorAlert("Please select at least one billboard");
        return false;
      }
      let billboards = [];
      for (let billboard of this.selectedBillBoards) {
        billboards.push({
          id: billboard.billboardId,
          amount: String(billboard.balance)
        });
      }
      this.transactionDetails = {
        token: this.token,
        moduleId: String(helper.getModuleId("Parking").id),
        countyId: this.countyId,
        totalAmount: String(this.sum),
        billboards: billboards
      };
      document.body.classList.add("modal-open");
      this.showPaymentModal = true;
    },
    closePaymentModal() {
      document.body.classList.remove("modal-open");
      this.showPaymentModal = false;
      this.loadBillBoards();
      (this.selectedBillBoards = []), (this.transactionDetails = {});
      this.sum = 0;
    },
    billboardChanged() {
      this.toggleSelectAll();
      this.calculateSum();
    },
    toggleSelectAll() {
      let eligibleBillboards = this.billboards.filter(billboard => {
        if (billboard.balance > "0") {
          return billboard;
        }
      });
      if (eligibleBillboards.length === this.selectedBillBoards.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    checkBillboard(billboard) {
      return billboard.balance === "0";
    },
    selectAll() {
      if (this.allSelected) {
        for (let billboard of this.billboards) {
          if (billboard.balance > "0") {
            this.selectedBillBoards.push(billboard);
          }
        }
      } else {
        this.selectedBillBoards = [];
      }
      this.calculateSum();
    }
  },
  created: function() {
    this.loadBillBoards();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/services/advertising/Advertising.vue